import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "buttons"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_RestaurantDetails = _resolveComponent("RestaurantDetails")!
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_RestaurantConfigurations = _resolveComponent("RestaurantConfigurations", true)!
  const _component_MainSection = _resolveComponent("MainSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection, null, {
      default: _withCtx(() => [
        (!_ctx.restaurantDetails)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.restaurantDetails)
          ? (_openBlock(), _createBlock(_component_RestaurantDetails, {
              key: 1,
              restaurant: _ctx.restaurantDetails,
              restaurantId: _ctx.restaurantId
            }, null, 8, ["restaurant", "restaurantId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_MainSection, null, {
      default: _withCtx(() => [
        (!_ctx.localConfigurations || !_ctx.localConfigurations.isReady)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.localConfigurations && _ctx.localConfigurations.isReady)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_RestaurantConfigurations, {
                definitions: _ctx.definitions,
                configurations: _ctx.localConfigurations.currentConfigs,
                onConfigChanged: _ctx.onConfigChanged
              }, null, 8, ["definitions", "configurations", "onConfigChanged"]),
              _hoisted_2,
              (_ctx.formState.isSubmitting)
                ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.formState.isSubmitting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light pull-right",
                      disabled: !_ctx.formState.hasChanged,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                    }, " Cancel ", 8, _hoisted_4),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary pull-right",
                      disabled: !_ctx.formState.hasChanged,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit()))
                    }, " Save ", 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}